"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Use = exports.TSpan = exports.TextPath = exports.Text = exports.Symbol = exports.Svg = exports.Stop = exports.Rect = exports.RadialGradient = exports.Polyline = exports.Polygon = exports.Path = exports.LinearGradient = exports.Line = exports.Image = exports.Ellipse = exports.Defs = exports.ClipPath = exports.Circle = exports.isWeb = void 0;
var react_native_1 = require("react-native");
var react_native_svg_1 = require("react-native-svg");
var react_native_svg_2 = require("react-native-svg");
var react_native_svg_3 = require("react-native-svg");
var react_native_svg_4 = require("react-native-svg");
var react_native_svg_5 = require("react-native-svg");
var react_native_svg_6 = require("react-native-svg");
var react_native_svg_7 = require("react-native-svg");
var react_native_svg_8 = require("react-native-svg");
var react_native_svg_9 = require("react-native-svg");
var react_native_svg_10 = require("react-native-svg");
var react_native_svg_11 = require("react-native-svg");
var react_native_svg_12 = require("react-native-svg");
var react_native_svg_13 = require("react-native-svg");
var react_native_svg_14 = require("react-native-svg");
var react_native_svg_15 = require("react-native-svg");
var react_native_svg_16 = require("react-native-svg");
var react_native_svg_17 = require("react-native-svg");
var react_native_svg_18 = require("react-native-svg");
var react_native_svg_19 = require("react-native-svg");
var svg_1 = require("./svg");
var svg_2 = require("./svg");
var svg_3 = require("./svg");
var svg_4 = require("./svg");
var svg_5 = require("./svg");
var svg_6 = require("./svg");
var svg_7 = require("./svg");
var svg_8 = require("./svg");
var svg_9 = require("./svg");
var svg_10 = require("./svg");
var svg_11 = require("./svg");
var svg_12 = require("./svg");
var svg_13 = require("./svg");
var svg_14 = require("./svg");
var svg_15 = require("./svg");
var svg_16 = require("./svg");
var svg_17 = require("./svg");
var svg_18 = require("./svg");
var svg_19 = require("./svg");
exports.isWeb = react_native_1.Platform.OS === "web";
exports.Circle = exports.isWeb ? svg_1.Circle : react_native_svg_1.Circle;
exports.ClipPath = exports.isWeb ? svg_2.ClipPath : react_native_svg_2.ClipPath;
exports.Defs = exports.isWeb ? svg_3.Defs : react_native_svg_3.Defs;
exports.Ellipse = exports.isWeb ? svg_4.Ellipse : react_native_svg_4.Ellipse;
exports.Image = exports.isWeb ? svg_5.Image : react_native_svg_5.Image;
exports.Line = exports.isWeb ? svg_6.Line : react_native_svg_6.Line;
exports.LinearGradient = exports.isWeb ? svg_7.LinearGradient : react_native_svg_7.LinearGradient;
exports.Path = exports.isWeb ? svg_8.Path : react_native_svg_8.Path;
exports.Polygon = exports.isWeb ? svg_9.Polygon : react_native_svg_9.Polygon;
exports.Polyline = exports.isWeb ? svg_10.Polyline : react_native_svg_10.Polyline;
exports.RadialGradient = exports.isWeb ? svg_11.RadialGradient : react_native_svg_11.RadialGradient;
exports.Rect = exports.isWeb ? svg_12.Rect : react_native_svg_12.Rect;
exports.Stop = exports.isWeb ? svg_13.Stop : react_native_svg_13.Stop;
exports.Svg = exports.isWeb ? svg_14.Svg : react_native_svg_14.Svg;
exports.Symbol = exports.isWeb ? svg_15.Symbol : react_native_svg_15.Symbol;
exports.Text = exports.isWeb ? svg_16.Text : react_native_svg_16.Text;
exports.TextPath = exports.isWeb ? svg_17.TextPath : react_native_svg_17.TextPath;
exports.TSpan = exports.isWeb ? svg_18.TSpan : react_native_svg_18.TSpan;
exports.Use = exports.isWeb ? svg_19.Use : react_native_svg_19.Use;
